/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Diagnosis } from './Diagnosis';
import {
    DiagnosisFromJSON,
    DiagnosisFromJSONTyped,
    DiagnosisToJSON,
} from './Diagnosis';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface DiagnosisPagination
 */
export interface DiagnosisPagination {
    /**
     * 
     * @type {Array<Diagnosis>}
     * @memberof DiagnosisPagination
     */
    data?: Array<Diagnosis>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof DiagnosisPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the DiagnosisPagination interface.
 */
export function instanceOfDiagnosisPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiagnosisPaginationFromJSON(json: any): DiagnosisPagination {
    return DiagnosisPaginationFromJSONTyped(json, false);
}

export function DiagnosisPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiagnosisPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(DiagnosisFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function DiagnosisPaginationToJSON(value?: DiagnosisPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(DiagnosisToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

